import React from 'react';
import { storageImage } from '../../lib/img';

const CHECK = (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const PLUS = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);
const GEAR = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

export default function AvatarDropdownMenu({
  collapsed,
  onClose, onNavigate, onSignOut,
  shows = [], activeShowId, onSelectShow, onManageShows,
  canCreateShow, onCreateShow,
}) {
  function go(view) { onClose?.(); onNavigate?.(view); }

  return (
    <div
      className={`avatar-dropdown-menu${collapsed ? ' avatar-dropdown-menu--rail' : ''}`}
      role="menu"
    >
      {shows && shows.length > 0 && (
        <>
          <div className="avatar-dropdown-label">Your shows</div>
          {shows.map(s => (
            <button
              key={s.id}
              type="button"
              className={`avatar-dropdown-show${s.id === activeShowId ? ' active' : ''}`}
              role="menuitemradio"
              aria-checked={s.id === activeShowId}
              onClick={() => { onClose?.(); onSelectShow?.(s); }}
            >
              <span
                className="avatar-dropdown-show-art"
                style={s.cover_art_url
                  ? { backgroundImage: `url(${storageImage(s.cover_art_url, { width: 200 })})` }
                  : { background: `linear-gradient(135deg, ${s.brand_color || '#ffb101'}, #0c0808)` }}
              />
              <span className="avatar-dropdown-show-name">{s.name}</span>
              {s.id === activeShowId && (
                <span className="avatar-dropdown-show-check">{CHECK}</span>
              )}
            </button>
          ))}
          {canCreateShow && onCreateShow && (
            <button
              type="button"
              className="avatar-dropdown-item avatar-dropdown-item--inline"
              role="menuitem"
              onClick={() => { onClose?.(); onCreateShow?.(); }}
            >
              <span className="avatar-dropdown-item-icon">{PLUS}</span>
              New show
            </button>
          )}
          <button
            type="button"
            className="avatar-dropdown-item avatar-dropdown-item--inline"
            role="menuitem"
            onClick={() => { onClose?.(); onManageShows?.(); }}
          >
            <span className="avatar-dropdown-item-icon">{GEAR}</span>
            Manage shows
          </button>
          <div className="avatar-dropdown-divider" />
        </>
      )}

      <button type="button" className="avatar-dropdown-item" role="menuitem" onClick={() => go('profile')}>
        Profile
      </button>
      {/* Show DNA lives inside Shows Manager now (reachable via the
          "Manage shows" entry above). No separate dropdown destination —
          the standalone Settings tab + this redirect were removed so
          there's exactly one route to that surface. */}
      <button type="button" className="avatar-dropdown-item" role="menuitem" onClick={() => go('subscription')}>
        Subscription
      </button>
      <button type="button" className="avatar-dropdown-item" role="menuitem" onClick={() => go('account')}>
        Account
      </button>

      {/* Theme submenu removed per design — single dark theme only. */}

      <div className="avatar-dropdown-divider" />
      <button
        type="button"
        className="avatar-dropdown-item avatar-dropdown-item--signout"
        role="menuitem"
        onClick={() => { onClose?.(); onSignOut?.(); }}
      >
        Sign out
      </button>
    </div>
  );
}
